/**
 * Modèles de facture : les cas récurrents de l'ABFT, pré-remplis.
 *
 * Un modèle ne fixe que les libellés et les tarifs connus ; tout reste
 * modifiable ensuite dans l'éditeur.
 */

import {normaliser, ligneVierge} from './modele'
import {tarif} from './tarifs'

export const MODELES = [
  {
    cle: 'cotisation',
    libelle: 'Cotisation annuelle',
    // L'année est reprise de la date d'émission quand elle n'est pas fournie
    lignes: function (parametres) {
      return [{
        description: 'Cotisation annuelle ' + parametres.annee,
        prixUnitaire: tarif('cotisationAnnuelle')
      }]
    }
  },
  {
    cle: 'formation_adeps',
    libelle: 'Formation ADEPS',
    lignes: function () {
      return [{description: 'Formation ADEPS', prixUnitaire: tarif('formationAdeps')}]
    }
  },
  {
    cle: 'fap_arbitrage_combat',
    libelle: 'FAP — Formation arbitrage combat',
    lignes: function () {
      return [{description: 'Formation arbitrage combat', prixUnitaire: tarif('fapArbitrageCombat')}]
    }
  },
  {
    cle: 'fap_arbitrage_technique',
    libelle: 'FAP — Formation arbitrage technique',
    lignes: function () {
      return [{description: 'Formation arbitrage technique', prixUnitaire: tarif('fapArbitrageTechnique')}]
    }
  },
  {
    cle: 'fap_carte_coach',
    libelle: 'FAP — Carte coach',
    lignes: function () {
      return [{description: 'Carte coach', prixUnitaire: tarif('fapCarteCoach')}]
    }
  },
  {
    cle: 'examen_grade',
    libelle: 'Examen de passage de grade',
    lignes: function () {
      return [{description: 'Examen de passage de grade', prixUnitaire: tarif('examenDan')}]
    }
  },
  {
    cle: 'diplome_kukkiwon',
    libelle: 'Diplôme Kukkiwon',
    lignes: function () {
      return [{description: 'Diplôme Kukkiwon', prixUnitaire: tarif('diplomeKukkiwon')}]
    }
  }
]

export function modeleParCle (cle) {
  return MODELES.filter(function (modele) { return modele.cle === cle })[0] || null
}

function anneeDeLaFacture (facture) {
  const correspondance = /^\d{2}\/\d{2}\/(\d{4})$/.exec(facture.dateEmission || '')
  return correspondance ? parseInt(correspondance[1], 10) : new Date().getFullYear()
}

/**
 * Renvoie une COPIE de la facture dont les lignes sont celles du modèle.
 * La facture reçue n'est jamais modifiée : l'appelant décide s'il remplace
 * l'état courant.
 */
export function appliquerModele (facture, cle, parametres) {
  const modele = modeleParCle(cle)
  const copie = normaliser(facture)
  if (!modele) return copie

  const options = parametres || {}
  const contexte = {annee: options.annee || anneeDeLaFacture(copie)}

  copie.lignes = modele.lignes(contexte).map(function (ligne) {
    return Object.assign(ligneVierge(), {
      description: ligne.description,
      quantite: ligne.quantite === undefined ? 1 : ligne.quantite,
      prixUnitaire: ligne.prixUnitaire || 0
    })
  })
  copie.modele = modele.cle
  return copie
}

export default {MODELES, modeleParCle, appliquerModele}



// WEBPACK FOOTER //
// ./src/utils/facture/modeles.js